import React from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa';
import styles from './Grilla.module.css';

interface FavoriteProps {
  id: number;
  isFavorite: boolean;
  onToggle: (id: number) => void;
  onNotify?: (message: string, type?: 'success' | 'error') => void;
}

const Favorite: React.FC<FavoriteProps> = ({ id, isFavorite, onToggle, onNotify }) => {
  const handleClick = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/agenda/favoritos${isFavorite ? `/${id}` : ''}`, {
        method: isFavorite ? 'DELETE' : 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: isFavorite ? null : JSON.stringify({ id_funcionario: id }),
        credentials: "include"
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error al actualizar favorito:', errorData);
        onNotify?.('Hubo un error al actualizar el favorito.', 'error');
        return;
      }

        onToggle(id);
        onNotify?.(
          isFavorite ? 'Se quitó de Favoritos correctamente' : 'Se marcó como Favorito correctamente',
          'success'
        );
    } catch (error) {
      console.error('Error en la solicitud de favorito:', error);
        onNotify?.('Error en la conexión con el servidor', 'error');
    }
  };

  return (
    <span
      className={styles.starIcon}
      onClick={handleClick}
      title={isFavorite ? 'Quitar de favoritos' : 'Marcar como favorito'}
    >
      {isFavorite ? <FaStar /> : <FaRegStar />}
    </span>
  );
};

export default Favorite;